import { isEmpty } from 'lodash-es';
import moment from 'moment';

type DaypartingInterval = [moment.Moment, moment.Moment][];

export interface IDaypartingDays {
  Monday: DaypartingInterval;
  Tuesday: DaypartingInterval;
  Wednesday: DaypartingInterval;
  Thursday: DaypartingInterval;
  Friday: DaypartingInterval;
  Saturday: DaypartingInterval;
  Sunday: DaypartingInterval;
}

export const emptyDaypartingDays = {
  Monday: [],
  Tuesday: [],
  Wednesday: [],
  Thursday: [],
  Friday: [],
  Saturday: [],
  Sunday: [],
} as IDaypartingDays;

export interface IDaypartingParsed {
  Enabled: boolean;
  Timezone: string;
  Schedule: {
    Monday: Array<string[]>;
    Tuesday: Array<string[]>;
    Wednesday: Array<string[]>;
    Thursday: Array<string[]>;
    Friday: Array<string[]>;
    Saturday: Array<string[]>;
    Sunday: Array<string[]>;
  };
  EnableViewerTimezone: boolean;
}

export const defaultDaypartingParsed: IDaypartingParsed = {
  Enabled: false,
  Timezone: 'UTC',
  Schedule: {
    Monday: [],
    Tuesday: [],
    Wednesday: [],
    Thursday: [],
    Friday: [],
    Saturday: [],
    Sunday: [],
  },
  EnableViewerTimezone: false,
};

export interface IDaypartingPeriod {
  reactKey: string | number; // MUST BE UNIQUE
  start: moment.Moment;
  end: moment.Moment;
  days: Set<string>;
}

export interface IDaypartingUI {
  Enabled: boolean;
  Timezone: string;
  EnableViewerTimezone: boolean;
  Periods: IDaypartingPeriod[];
}

export const defaultDaypartingUI: IDaypartingUI = {
  Enabled: false,
  Timezone: 'UTC',
  EnableViewerTimezone: false,
  Periods: [],
};

const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

export const generateDaypartingPeriods = (schedule: Record<string, string[][]>) => {
  let reactKey = 1001;
  const periods = {} as Record<string, IDaypartingPeriod>;
  days.forEach((day) => {
    // @ts-ignore
    (schedule[day] || []).forEach((pair: string[]) => {
      if (pair.length === 2) {
        const key = pair[0] + '-' + pair[1];
        if (periods[key]) {
          periods[key].days.add(day);
        } else {
          periods[key] = {
            reactKey,
            start: moment(pair[0], 'HH:mm'),
            end: moment(pair[1], 'HH:mm'),
            days: new Set([day]),
          };
          reactKey++;
        }
      }
    });
  });
  if (isEmpty(periods)) {
    return [
      {
        reactKey,
        start: moment('00:00', 'HH:mm'),
        end: moment('12:00', 'HH:mm'),
        days: new Set([]),
      },
    ];
  }
  return Object.values(periods);
};
